import PropTypes from "prop-types";

function LocationUrlCard({ locationUrl }) {
  return (
    <iframe
      className="rounded-lg"
      src={locationUrl}
      width="100%"
      height="380"
      style={{ border: 0 }}
      allow="fullscreen"
      loading="lazy"
    ></iframe>
  );
}

LocationUrlCard.propTypes = {
  locationUrl: PropTypes.string,
};

LocationUrlCard.defaultProps = {
  locationUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.0753743571877!2d90.41758426870395!3d23.815918610907648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7645f4d2aeb%3A0xf870e7ed1e780d80!2sAmarPet!5e0!3m2!1sbn!2sbd!4v1697961851254!5m2!1sbn!2sbd",
};

export default LocationUrlCard;
